import Clickable from "@components/clickable"
import FixedBottomButtons from "@components/fixedBottomButtons"
import Indie from "@components/pages/new_image/indie"
import Widget from "@components/widget"
import config, { cdnUrl } from "@config"
import widgetImg from "@images/BOOOM.jpeg"
import mapImg from "@images/map.png"
import APP_1_1 from "@images/new_image/app/APP_1_1.png"
import APP_1_2 from "@images/new_image/app/APP_1_2.png"
import APP_1_3 from "@images/new_image/app/APP_1_3.png"
import APP_1_4 from "@images/new_image/app/APP_1_4.png"
import APP_2_1 from "@images/new_image/app/APP_2_1.png"
import APP_2_2 from "@images/new_image/app/APP_2_2.png"
import APP_3_1 from "@images/new_image/app/APP_3_1.png"
import APP_3_2 from "@images/new_image/app/APP_3_2.png"
import APP_3_3_1 from "@images/new_image/app/APP_3_3_1.png"
import APP_3_3_2 from "@images/new_image/app/APP_3_3_2.png"
import APP_3_3_3 from "@images/new_image/app/APP_3_3_3.png"
import APP_3_5 from "@images/new_image/app/APP_3_5.png"
import APP_4_1 from "@images/new_image/app/APP_4_1.png"
import APP_4_2 from "@images/new_image/app/APP_4_2.png"
import APP_4_3 from "@images/new_image/app/APP_4_3.png"
import APP_4_4 from "@images/new_image/app/APP_4_4.png"
import APP_4_5 from "@images/new_image/app/APP_4_5.png"
import APP_5 from "@images/new_image/app/APP_5.png"
import PC_1_1 from "@images/new_image/pc/PC_1_1.png"
import PC_1_2 from "@images/new_image/pc/PC_1_2.png"
import PC_1_3 from "@images/new_image/pc/PC_1_3.png"
import PC_1_4 from "@images/new_image/pc/PC_1_4.png"
import PC_2_1 from "@images/new_image/pc/PC_2_1.png"
import PC_2_2 from "@images/new_image/pc/PC_2_2.png"
import PC_3_1 from "@images/new_image/pc/PC_3_1.png"
import PC_3_2 from "@images/new_image/pc/PC_3_2.png"
import PC_3_3_1 from "@images/new_image/pc/PC_3_3_1.png"
import PC_3_3_2 from "@images/new_image/pc/PC_3_3_2.png"
import PC_3_3_3 from "@images/new_image/pc/PC_3_3_3.png"
import PC_3_4 from "@images/new_image/pc/PC_3_4.png"
import PC_3_5 from "@images/new_image/pc/PC_3_5.png"
import PC_4_1 from "@images/new_image/pc/PC_4_1.png"
import PC_4_2 from "@images/new_image/pc/PC_4_2.png"
import PC_4_3 from "@images/new_image/pc/PC_4_3.png"
import PC_4_4 from "@images/new_image/pc/PC_4_4.png"
import PC_4_5 from "@images/new_image/pc/PC_4_5.png"
import PC_5 from "@images/new_image/pc/PC_5.png"
import { AppContext } from "@src/context"
import classnames from "@utils/classnames"
import React, { useContext, useEffect, useState } from "react"
import styles from "./new_image.module.scss"

const IndexPage = React.memo(() => {
  const { renderItem, renderBanner, isAppLayout } = useContext(AppContext)
  const [fixedButtonsActive, setFixedButtonsActive] = useState(false)

  useEffect(() => {
    const scrollEvent = () => {
      const scrollTop = window.scrollY
      requestAnimationFrame(() => {
        setFixedButtonsActive(scrollTop > 500)
      })
    }
    scrollEvent()

    window.addEventListener("scroll", scrollEvent)
    return () => {
      window.removeEventListener("scroll", scrollEvent)
    }
  }, [])

  return (
    <div className="page">
      <div className={isAppLayout ? undefined : styles.pcHeader}>
        <div
          className={classnames(
            "container",
            isAppLayout ? styles.appHeaderContainer : styles.pcHeaderContainer
          )}
        >
          {renderItem(PC_1_1, APP_1_1)}
          <div className={styles.headerVideo}>
            <div>
              <iframe
                title="header"
                src="https://www.taptap.com/video/2045902/embed?thumb=https%3A%2F%2Fimg2.tapimg.com%2Fbbcode%2Fimages%2F83a50c828dba7e50a1226916e2abc981.png"
                frameborder="0"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        {renderItem(PC_1_2, APP_1_2)}
        {renderItem(PC_1_3, APP_1_3)}
        <Clickable appNavTo={`${cdnUrl}${mapImg}`}>
          {renderItem(PC_1_4, APP_1_4)}
        </Clickable>
      </div>
      {renderBanner(PC_2_1, APP_2_1, "2")}
      <div className="container">
        {renderItem(PC_2_2, APP_2_2)}
        <Indie renderItem={renderItem} isApp={isAppLayout} />
      </div>
      {renderBanner(PC_3_1, APP_3_1, "3")}
      <div className="container">
        {renderItem(PC_3_2, APP_3_2)}
        <div className={isAppLayout ? undefined : styles.pcCreativeTable}>
          <Clickable appNavTo={config.url.creatorEnroll}>
            {renderItem(PC_3_3_1, APP_3_3_1)}
          </Clickable>
          <Clickable appNavTo={config.url.article}>
            {renderItem(PC_3_3_2, APP_3_3_2)}
          </Clickable>
          <div>{renderItem(PC_3_3_3, APP_3_3_3)}</div>
        </div>
        {renderItem(
          () => {
            return (
              <Clickable appNavTo={config.url.team}>
                <img src={PC_3_4} alt="组队" />
              </Clickable>
            )
          },
          () => {
            return (
              <Widget
                title="BOOOM 活动组队"
                desc="关联话题"
                image={widgetImg}
                className={styles.appWidget}
                appNavTo={config.url.team}
              />
            )
          }
        )}
        <div
          className={classnames(
            isAppLayout
              ? styles.appBooomVideoContainer
              : styles.pcBooomVideoContainer
          )}
        >
          {renderItem(PC_3_5, APP_3_5)}
          <div className={styles.booomVideo}>
            <div>
              <iframe
                src="https://www.taptap.com/video/1952058/embed?thumb=https%3A%2F%2Fimg2.tapimg.com%2Fbbcode%2Fimages%2F016cab6cae67c0c4e6da36028db3cced.png"
                frameborder="0"
                title="teaser"
              />
            </div>
          </div>
        </div>
      </div>
      {renderBanner(PC_4_1, APP_4_1, "4")}
      <div className="container">
        {renderItem(PC_4_2, APP_4_2)}
        {renderItem(PC_4_3, APP_4_3)}
        {renderItem(PC_4_4, APP_4_4)}
        {renderItem(PC_4_5, APP_4_5)}
      </div>
      <div className={isAppLayout ? undefined : styles.pcFooter}>
        <div className="container">{renderItem(PC_5, APP_5)}</div>
      </div>
      <div className="theme-dark">
        <FixedBottomButtons active={fixedButtonsActive} />
      </div>
    </div>
  )
})

export default IndexPage
